import styled from 'styled-components';

const Container = styled.div`
  @keyframes borderAndShadowPulse {
    0% {
      border: 1px solid #e5ebee;
      box-shadow: 0 3px 10px 0 rgba(11, 26, 33, 0);
    }
    52.63% {
      border: 1px solid #e5ebee;
      box-shadow: 0 3px 10px 0 rgba(11, 26, 33, 0);
    }
    63.16% {
      border: 1px solid #0265dc;
      box-shadow: 0 3px 10px 0 rgba(11, 26, 33, 0.08);
    }
    89.47% {
      border: 1px solid #0265dc;
      box-shadow: 0 3px 10px 0 rgba(11, 26, 33, 0.08);
    }
    100% {
      border: 1px solid #e5ebee;
      box-shadow: 0 3px 10px 0 rgba(11, 26, 33, 0);
    }
  }
  .in-page-features-v9--item:hover {
    border: 1px solid var(--titan-blue-3);
  }
  .in-page-features-v9--item:not(:hover) {
    &.pulse-effect {
      animation: borderAndShadowPulse 3.8s ease-in-out infinite;
    }
  }
  .in-page-features-v9--item.item-selected {
    background-color: var(--titan-blue-3);
    border: 1px solid var(--titan-blue-3);
    p {
      color: white;
    }
    img {
      filter: brightness(0) invert(1);
    }
  }
`;

const DesktopContainer = styled.div`
  .in-page-features-v9--featured-content-heading {
    font-size: var(--font-size-p-md);
    letter-spacing: 0;
    display: inline;

    @media (max-width: 767px) {
      font-size: var(--font-size-mobile-p-md);
    }
  }

  .in-page-features-v9--featured-content-description {
    display: inline;

    @media (max-width: 991px) {
      padding: 0;
    }
  }

  .gatsby-image-wrapper {
    max-height: 500px;
    max-width: 100%;

    img {
      bottom: 0;
      right: 0;
      margin: auto;
    }
  }
`;

const MobileContainer = styled.div`
  .in-page-features-v9--featured-content-heading {
    font-size: var(--font-size-mobile-p-md);
    letter-spacing: 0;
    display: inline;
  }

  .in-page-features-v9--featured-content-description {
    display: inline;
  }

  .in-page-features-v9--mobile-featured-image-container {
    min-height: 350px;
    display: flex;
    align-items: center;
    justify-content: center;

    .website-image {
      text-align: center;
    }
  }
`;

export { Container, DesktopContainer, MobileContainer };
